import { DateRelativeTo, EntryPeriod } from "@gemma/utils";

import { CalendarDate } from "@gemma/dates";

export function datePickerDateEnabled(
  //
  date: Date,
  contractor: { entryPeriod: EntryPeriod },
  settingDefaults: { timesheetWeekStartsOn: { id: string }; dateRelativeTo: DateRelativeTo },
  {
    periodStartDate,
    periodEndDate,
  }: {
    periodStartDate?: Readonly<CalendarDate>;
    periodEndDate?: Readonly<CalendarDate> | ((calendarDate: Readonly<CalendarDate>) => Readonly<CalendarDate>);
  } = {}
) {
  const pickerDateToCheck = CalendarDate.parse(date) as Readonly<CalendarDate>;
  const isBeforePeriodStartDate = pickerDateToCheck.isBefore(periodStartDate);
  const isAfterPeriodEndDate = pickerDateToCheck.isAfter(typeof periodEndDate === "function" ? periodEndDate(pickerDateToCheck) : periodEndDate);
  if (isBeforePeriodStartDate || isAfterPeriodEndDate) {
    return false;
  }

  if (contractor.entryPeriod.isWeekly) {
    const isEnabled = settingDefaults.timesheetWeekStartsOn.id === pickerDateToCheck.day.id;

    return isEnabled;
  } else if (contractor.entryPeriod.isCalendarMonthly) {
    const isEnabled = settingDefaults.dateRelativeTo.isBeginning ? pickerDateToCheck.date === 1 : pickerDateToCheck.isLastDayOfMonth;

    return isEnabled;
  }

  return false;
}
